module.exports = __webpack_public_path__ + "components/flag/static/square/dm-36b0e42fefbd23c4a32820fe0a56047b.svg";